import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class strings safely, deduplicating conflicting utilities.
 *
 * Combines `clsx` (conditional class composition) with `tailwind-merge`
 * (last-write-wins for conflicting Tailwind utilities like `p-2` + `p-4`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
